<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
        class="filter-btn mt-3"
      >
        <v-icon left class="material-icons-round">search</v-icon>
        Find Vehicles
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline d-flex justify-space-between align-center">
        <div class="d-flex align-center text-h6">
          Start a New Search
        </div>
        <div>
          <v-btn text color="primary" @click="clearForm" class="mr-2">
            <v-icon left small class="material-icons-round">refresh</v-icon>
            CLEAR
          </v-btn>
          <v-btn icon @click="closeDialog" class="close-btn">
            <v-icon class="material-icons-round">close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <v-row>
            <!-- Make Column -->
            <v-col cols="12" md="6">
              <h3 class="mb-2 text-h6">MAKE </h3>
              <v-text-field
                v-model="makeSearch"
                label="Filter makes"
                outlined
                dense
                clearable
                @click:clear="resetMakeFilter"
                class="mb-2"
              ></v-text-field>
              <div class="makes-list" style="max-height: 300px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
                <div class="all-makes mb-2 d-flex justify-space-between align-center py-1 state-item">
                  <div>
                    <v-checkbox
                      :input-value="allMakesSelected"
                      class="state-checkbox ma-0 pa-0"
                      hide-details
                      dense
                      @change="allMakesSelected = !allMakesSelected; toggleAllMakes()"
                    >
                      <template v-slot:label>
                        <span class="font-weight-bold">ALL MAKES</span>
                      </template>
                    </v-checkbox>
                  </div>
                  <div v-if="selectedMakes.length > 0" class="selected-count primary--text">
                    {{ selectedMakes.length }} selected
                  </div>
                </div>
                <div v-for="(make, index) in filteredMakeOptions" :key="index" class="state-item d-flex justify-space-between align-center py-1">
                  <div>
                    <v-checkbox
                      :input-value="isMakeSelected(make.make)"
                      class="state-checkbox ma-0 pa-0"
                      hide-details
                      dense
                      @change="toggleMakeSelection(make.make)"
                    >
                      <template v-slot:label>
                        <span>{{ make.make }}</span>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
                <div v-if="filteredMakeOptions.length === 0" class="text-center pa-3 grey--text">
                  No makes match your search
                </div>
              </div>
            </v-col>

            <!-- Model Column -->
            <v-col cols="12" md="6">
              <h3 class="mb-2 text-h6">MODEL </h3>
              <v-text-field
                v-model="modelSearch"
                label="Filter models"
                outlined
                dense
                clearable
                @click:clear="resetModelFilter"
                class="mb-2"
                :disabled="!selectedMakes.length"
              ></v-text-field>
              <div class="models-list" style="max-height: 300px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
                <div class="all-models mb-2 d-flex justify-space-between align-center py-1 state-item" v-if="filteredModelOptions.length > 0">
                  <div>
                    <v-checkbox
                      :input-value="allModelsSelected"
                      class="state-checkbox ma-0 pa-0"
                      hide-details
                      dense
                      :disabled="!selectedMakes.length"
                      @change="allModelsSelected = !allModelsSelected; toggleAllModels()"
                    >
                      <template v-slot:label>
                        <span class="font-weight-bold">ALL MODELS</span>
                      </template>
                    </v-checkbox>
                  </div>
                  <div v-if="selectedModels.length > 0" class="selected-count primary--text">
                    {{ selectedModels.length }} selected
                  </div>
                </div>
                <div v-for="(model, index) in filteredModelOptions" :key="index" class="state-item d-flex justify-space-between align-center py-1">
                  <div>
                    <v-checkbox
                      :input-value="isModelSelected(model.model)"
                      class="state-checkbox ma-0 pa-0"
                      hide-details
                      dense
                      :disabled="!selectedMakes.length"
                      @change="toggleModelSelection(model.model)"
                    >
                      <template v-slot:label>
                        <span>{{ model.model }}</span>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
                <div v-if="filteredModelOptions.length === 0 && selectedMakes.length > 0" class="text-center pa-3 grey--text">
                  No models match your search
                </div>
                <div v-if="!selectedMakes.length" class="text-center pa-3 grey--text">
                  Select a make first
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <!-- Year -->
            <v-col cols="12" md="6">
              <h3 class="mb-2 text-h6">Year</h3>
              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model="filter.year_min"
                    :items="year_option"
                    label="All"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="filter.year_max"
                    :items="year_option"
                    label="All"
                    outlined
                    dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

            <!-- Odometer -->
            <v-col cols="12" md="6">
              <h3 class="mb-2 text-h6">Odometer</h3>
              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model="filter.odometer_min"
                    :items="odometer_options"
                    label="No min"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="filter.odometer_max"
                    :items="odometer_options"
                    label="No max"
                    outlined
                    dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <!-- Price Range -->
            <v-col cols="12" md="6">
              <h3 class="mb-2 text-h6">Price Range</h3>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="filter.price_min"
                    label="No min"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="filter.price_max"
                    label="No max"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <!-- Zip Code and Radius -->
            <v-col cols="12" md="6">
              <h3 class="mb-2 text-h6">Search Area</h3>
              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model.number="filter.radius"
                    :items="radius_options"
                    outlined
                    dense
                    label="Radius"
                  ></v-select>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <span class="" style="margin-top: -25px;margin-left: -10px;margin-right: 5px;margin-left: -15px;">of</span>
                  <v-combobox
                    v-model="selectedZipCodes"
                    label="ZIP Code"
                    outlined
                    dense
                    chips
                    small-chips
                    multiple
                    persistent-hint
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- States Section -->
          <v-row>
            <v-col cols="12">
              <h3 class="mb-2 text-h6">STATES</h3>
              <v-text-field
                v-model="stateSearch"
                label="Filter states"
                outlined
                dense
                clearable
                @click:clear="stateSearch = ''"
                class="mb-2"
              ></v-text-field>
              <div class="states-list" style="max-height: 200px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
                <div v-for="(state, index) in filteredStates" :key="index" class="state-item d-flex justify-space-between align-center py-1">
                  <div>
                    <v-checkbox
                      :input-value="isStateSelected(state.code)"
                      class="state-checkbox ma-0 pa-0"
                      hide-details
                      dense
                      @change="toggleStateSelection(state.code)"
                    >
                      <template v-slot:label>
                        <span>{{ state.code }} - {{ state.name }}</span>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
                <div v-if="filteredStates.length === 0" class="text-center pa-3 grey--text">
                  No states match your search
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green"
          large
          block
          dark
          @click="search"
          :disabled="isSearching"
        >
          <v-progress-circular
            v-if="isSearching"
            indeterminate
            size="20"
            width="2"
            class="mr-2"
          ></v-progress-circular>
          {{ isSearching ? 'SEARCHING...' : `SHOW VEHICLES` }}
        </v-btn>
      </v-card-actions>

      <!-- Floating close button -->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InventoryFilterModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initialFilter: {
      type: Object,
      default: () => ({})
    },
    vehicleCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: this.value,
      isSearching: false,
      makeSearch: '',
      modelSearch: '',
      stateSearch: '',
      allMakesSelected: false,
      allModelsSelected: false,
      selectedMakes: [],
      selectedModels: [],
      selectedStates: [],
      selectedZipCodes: [],
      filter: {
        type: 'All',
        year_min: '',
        year_max: '',
        price_min: '',
        price_max: '',
        odometer_min: '',
        odometer_max: '',
        radius: 50,
      },
      // Map of states to central zip codes
      stateZipMap: {
        'AL': '35801', // Alabama - Huntsville
        'AK': '99501', // Alaska - Anchorage
        'AZ': '85001', // Arizona - Phoenix
        'AR': '72201', // Arkansas - Little Rock
        'CA': '95814', // California - Sacramento
        'CO': '80202', // Colorado - Denver
        'CT': '06103', // Connecticut - Hartford
        'DE': '19901', // Delaware - Dover
        'FL': '32301', // Florida - Tallahassee
        'GA': '30303', // Georgia - Atlanta
        'HI': '96813', // Hawaii - Honolulu
        'ID': '83702', // Idaho - Boise
        'IL': '62701', // Illinois - Springfield
        'IN': '46204', // Indiana - Indianapolis
        'IA': '50309', // Iowa - Des Moines
        'KS': '66603', // Kansas - Topeka
        'KY': '40601', // Kentucky - Frankfort
        'LA': '70802', // Louisiana - Baton Rouge
        'ME': '04330', // Maine - Augusta
        'MD': '21401', // Maryland - Annapolis
        'MA': '02201', // Massachusetts - Boston
        'MI': '48933', // Michigan - Lansing
        'MN': '55101', // Minnesota - St. Paul
        'MS': '39201', // Mississippi - Jackson
        'MO': '65101', // Missouri - Jefferson City
        'MT': '59601', // Montana - Helena
        'NE': '68502', // Nebraska - Lincoln
        'NV': '89701', // Nevada - Carson City
        'NH': '03301', // New Hampshire - Concord
        'NJ': '08608', // New Jersey - Trenton
        'NM': '87501', // New Mexico - Santa Fe
        'NY': '12207', // New York - Albany
        'NC': '27601', // North Carolina - Raleigh
        'ND': '58501', // North Dakota - Bismarck
        'OH': '43215', // Ohio - Columbus
        'OK': '73102', // Oklahoma - Oklahoma City
        'OR': '97301', // Oregon - Salem
        'PA': '17101', // Pennsylvania - Harrisburg
        'RI': '02903', // Rhode Island - Providence
        'SC': '29201', // South Carolina - Columbia
        'SD': '57501', // South Dakota - Pierre
        'TN': '37219', // Tennessee - Nashville
        'TX': '78701', // Texas - Austin
        'UT': '84111', // Utah - Salt Lake City
        'VT': '05602', // Vermont - Montpelier
        'VA': '23219', // Virginia - Richmond
        'WA': '98501', // Washington - Olympia
        'WV': '25301', // West Virginia - Charleston
        'WI': '53703', // Wisconsin - Madison
        'WY': '82001', // Wyoming - Cheyenne
        'DC': '20001'  // District of Columbia - Washington
      },
      make_option: [],
      model_option: [],
      original_make_option: [],
      original_model_option: [],
      year_option: [],
      odometer_options: [
        1000, 5000, 10000, 20000, 30000, 40000, 50000,
        60000, 70000, 80000, 90000, 100000, 110000, 120000,
        130000, 140000
      ],
      radius_options: [50, 100, 200, 250, 500, 750, 1000, 1500, 2000],
      states: [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' },
        { code: 'DC', name: 'District of Columbia' }
      ]
    };
  },
  computed: {
    filteredMakeOptions() {
      if (!this.makeSearch) {
        return this.original_make_option;
      }
      const searchTerm = this.makeSearch.toLowerCase();
      return this.original_make_option.filter(item =>
        item.make.toLowerCase().includes(searchTerm)
      );
    },
    filteredModelOptions() {
      if (!this.modelSearch) {
        return this.original_model_option;
      }
      const searchTerm = this.modelSearch.toLowerCase();
      return this.original_model_option.filter(item =>
        item.model.toLowerCase().includes(searchTerm)
      );
    },
    filteredStates() {
      if (!this.stateSearch) {
        return this.states;
      }
      const searchTerm = this.stateSearch.toLowerCase();
      return this.states.filter(state =>
        state.code.toLowerCase().includes(searchTerm) ||
        state.name.toLowerCase().includes(searchTerm)
      );
    }
  },
  watch: {
    value(val) {
      this.dialog = val;

      // When the modal is opened, load saved filters only if initialFilter is empty
      if (val) {
        // Only load saved filters if initialFilter is empty
        const hasInitialFilter = Object.keys(this.initialFilter).some(key =>
          this.initialFilter[key] !== '' && this.initialFilter[key] !== null && this.initialFilter[key] !== undefined
        );

        if (!hasInitialFilter) {
          this.loadSavedFilters();
        }
      }
    },
    dialog(val) {
      this.$emit('input', val);

      // When the modal is opened, load saved filters only if initialFilter is empty
      if (val) {
        // Only load saved filters if initialFilter is empty
        const hasInitialFilter = Object.keys(this.initialFilter).some(key =>
          this.initialFilter[key] !== '' && this.initialFilter[key] !== null && this.initialFilter[key] !== undefined
        );

        if (!hasInitialFilter) {
          this.loadSavedFilters();
        }
      }
    },
    initialFilter: {
      handler(newVal) {
        // Apply initialFilter values to our local filter
        this.filter = { ...this.filter, ...newVal };

        // If initialFilter has makes/models/states/zip_codes, apply them to our local arrays
        if (newVal.makes && Array.isArray(newVal.makes)) {
          this.selectedMakes = [...newVal.makes];
          this.updateModelOptions();
        } else if (newVal.make) {
          this.selectedMakes = [newVal.make];
          this.updateModelOptions();
        }

        if (newVal.models && Array.isArray(newVal.models)) {
          this.selectedModels = [...newVal.models];
        } else if (newVal.model) {
          this.selectedModels = [newVal.model];
        }

        if (newVal.states && Array.isArray(newVal.states)) {
          this.selectedStates = [...newVal.states];
        }

        if (newVal.zip_codes && Array.isArray(newVal.zip_codes)) {
          this.selectedZipCodes = [...newVal.zip_codes];
        } else if (newVal.zip_code) {
          this.selectedZipCodes = [newVal.zip_code];
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.fetchMakes();
    this.generateYearOptions();

    // Only load saved filters if initialFilter is empty
    const hasInitialFilter = Object.keys(this.initialFilter).some(key =>
      this.initialFilter[key] !== '' && this.initialFilter[key] !== null && this.initialFilter[key] !== undefined
    );

    if (!hasInitialFilter) {
      this.loadSavedFilters();
    }
  },
  methods: {
    loadSavedFilters() {
      try {
        console.log("Loading saved filters...");

        // First check URL parameters
        const urlParams = this.$route.query;
        let filterSource = null;

        if (Object.keys(urlParams).length > 0) {
          console.log("Found URL parameters, using them for filters:", urlParams);
          filterSource = urlParams;
        } else {
          // If no URL parameters, check localStorage
          const savedFilters = localStorage.getItem('vehicle_filter');
          if (savedFilters) {
            const filters = JSON.parse(savedFilters);
            console.log("Found saved filters in localStorage:", filters);

            // Check if filters are recent (within the last 24 hours)
            const now = new Date().getTime();
            const filterTime = filters.timestamp || 0;
            const isRecent = (now - filterTime) < (24 * 60 * 60 * 1000); // 24 hours

            if (isRecent) {
              console.log("Filters are recent, using them");
              filterSource = filters;
            } else {
              console.log("Filters are old, not using them");
            }
          } else {
            console.log("No saved filters found");
          }
        }

        // If we have filters from either source, apply them
        if (filterSource) {
          // Restore selected makes
          if (filterSource.makes) {
            // Handle both array and comma-separated string
            const makes = Array.isArray(filterSource.makes)
              ? filterSource.makes
              : filterSource.makes.split(',');

            if (makes.length > 0 && makes[0] !== '') {
              this.selectedMakes = makes;
              console.log("Restored makes:", this.selectedMakes);

              // Update the allMakesSelected checkbox if all makes are selected
              if (this.original_make_option.length > 0) {
                this.allMakesSelected = this.selectedMakes.length === this.original_make_option.length;
              }

              // Load models for the selected makes
              this.updateModelOptions();
            }
          } else if (filterSource.make) {
            // Handle single make parameter
            if (filterSource.make) {
              this.selectedMakes = [filterSource.make];
              console.log("Restored single make:", this.selectedMakes);
              this.updateModelOptions();
            }
          }

          // Restore selected models
          if (filterSource.models) {
            // Handle both array and comma-separated string
            const models = Array.isArray(filterSource.models)
              ? filterSource.models
              : filterSource.models.split(',');

            if (models.length > 0 && models[0] !== '') {
              this.selectedModels = models;
              console.log("Restored models:", this.selectedModels);
            }
          } else if (filterSource.model) {
            // Handle single model parameter
            if (filterSource.model) {
              this.selectedModels = [filterSource.model];
              console.log("Restored single model:", this.selectedModels);
            }
          }

          // Restore selected states
          if (filterSource.states) {
            // Handle both array and comma-separated string
            const states = Array.isArray(filterSource.states)
              ? filterSource.states
              : filterSource.states.split(',');

            if (states.length > 0 && states[0] !== '') {
              this.selectedStates = states;
              console.log("Restored states:", this.selectedStates);
            }
          }

          // Restore zip codes
          if (filterSource.zip_codes) {
            // Handle both array and comma-separated string
            const zipCodes = Array.isArray(filterSource.zip_codes)
              ? filterSource.zip_codes
              : filterSource.zip_codes.split(',');

            if (zipCodes.length > 0 && zipCodes[0] !== '') {
              this.selectedZipCodes = zipCodes;
              console.log("Restored zip codes:", this.selectedZipCodes);
            }
          } else if (filterSource.zip_code) {
            // Handle single zip code parameter
            if (filterSource.zip_code) {
              this.selectedZipCodes = [filterSource.zip_code];
              console.log("Restored single zip code:", this.selectedZipCodes);
            }
          }

          // Restore filter values
          this.filter = {
            ...this.filter,
            year_min: filterSource.year_min || filterSource.year || '',
            year_max: filterSource.year_max || '',
            price_min: filterSource.price_min || '',
            price_max: filterSource.price_max || '',
            odometer_min: filterSource.odometer_min || '',
            odometer_max: filterSource.odometer_max || '',
            radius: filterSource.radius ? parseInt(filterSource.radius) : 50,
            bodyStyle: filterSource.body_style || filterSource.bodyStyle || ''
          };

          console.log("Set radius to:", this.filter.radius, "from value:", filterSource.radius);

          console.log("Restored filter values:", this.filter);
        }
      } catch (error) {
        console.error('Error loading saved filters:', error);
      }
    },

    closeDialog() {
      this.dialog = false;
    },
    clearForm() {
      this.selectedMakes = [];
      this.selectedModels = [];
      this.selectedStates = [];
      this.selectedZipCodes = [];
      this.filter = {
        type: 'All',
        year_min: '',
        year_max: '',
        price_min: '',
        price_max: '',
        odometer_min: '',
        odometer_max: '',
        radius: 50,
      };
      this.makeSearch = '';
      this.modelSearch = '';
      this.stateSearch = '';
      this.allMakesSelected = false;
      this.allModelsSelected = false;
    },
    resetMakeFilter() {
      this.makeSearch = '';
    },
    resetModelFilter() {
      this.modelSearch = '';
    },
    toggleAllMakes() {
      // We're now toggling allMakesSelected in the template
      if (this.allMakesSelected) {
        // Select all makes (not just the filtered ones)
        this.selectedMakes = this.original_make_option.map(make => make.make);
      } else {
        this.selectedMakes = [];
      }
      this.updateModelOptions();
    },

    toggleAllModels() {
      // We're toggling allModelsSelected in the template
      if (this.allModelsSelected) {
        // Select all models (not just the filtered ones)
        this.selectedModels = this.original_model_option.map(model => model.model);
      } else {
        this.selectedModels = [];
      }
    },

    // Check if a make is selected (used for v-model binding)
    isMakeSelected(make) {
      return this.selectedMakes.includes(make);
    },

    // Toggle a specific make selection
    toggleMakeSelection(make) {
      const index = this.selectedMakes.indexOf(make);
      if (index === -1) {
        this.selectedMakes.push(make);
      } else {
        this.selectedMakes.splice(index, 1);
      }
      this.updateModelOptions();
    },

    // Check if a model is selected (used for v-model binding)
    isModelSelected(model) {
      return this.selectedModels.includes(model);
    },

    // Toggle a specific model selection
    toggleModelSelection(model) {
      const index = this.selectedModels.indexOf(model);
      if (index === -1) {
        this.selectedModels.push(model);
      } else {
        this.selectedModels.splice(index, 1);
      }
    },

    // Check if a state is selected (used for v-model binding)
    isStateSelected(stateCode) {
      return this.selectedStates.includes(stateCode);
    },

    // Toggle a specific state selection
    toggleStateSelection(stateCode) {
      const index = this.selectedStates.indexOf(stateCode);
      if (index === -1) {
        this.selectedStates.push(stateCode);
      } else {
        this.selectedStates.splice(index, 1);
      }
    },
    fetchMakes() {
      this.api_loading = true;
      axios.get('/api/get-vehicle-makes')
        .then(response => {
          if (response.data && response.data.flag === 1) {
            this.make_option = response.data.makes;
            this.original_make_option = [...this.make_option];
          } else {
            // Fallback to NHTSA API if our API fails
            this.fetchMakesFromNHTSA();
          }
          this.api_loading = false;
        })
        .catch(() => {
          this.api_loading = false;
          this.fetchMakesFromNHTSA();
        });
    },
    fetchMakesFromNHTSA() {
      axios.get('https://vpic.nhtsa.dot.gov/api/vehicles/getallmakes?format=json')
        .then(response => {
          if (response.data && response.data.Results) {
            const sortedMakes = response.data.Results.sort((a, b) =>
              a.Make_Name.localeCompare(b.Make_Name)
            );
            const mappedMakes = sortedMakes.map(make => ({
              make: make.Make_Name
            }));
            this.make_option = mappedMakes;
            this.original_make_option = [...mappedMakes];
          }
        });
    },
    updateModelOptions() {
      if (this.selectedMakes.length > 0) {
        this.fetchModels(this.selectedMakes);
      } else {
        this.model_option = [];
        this.original_model_option = [];
        this.selectedModels = [];
      }
    },
    fetchModels(makes) {
      this.api_loading = true;
      axios.post('/api/get-vehicle-models', { makes })
        .then(response => {
          if (response.data && response.data.flag === 1) {
            this.model_option = response.data.models;
            this.original_model_option = [...this.model_option];
          } else {
            // Fallback to NHTSA API for the first make if our API fails
            this.fetchModelsFromNHTSA(makes[0]);
          }
          this.api_loading = false;
        })
        .catch(() => {
          this.api_loading = false;
          if (makes.length > 0) {
            this.fetchModelsFromNHTSA(makes[0]);
          }
        });
    },
    fetchModelsFromNHTSA(make) {
      axios.get(`https://vpic.nhtsa.dot.gov/api/vehicles/getmodelsformake/${encodeURIComponent(make)}?format=json`)
        .then(response => {
          if (response.data && response.data.Results) {
            const sortedModels = response.data.Results.sort((a, b) =>
              a.Model_Name.localeCompare(b.Model_Name)
            );
            const mappedModels = sortedModels.map(model => ({
              model: model.Model_Name
            }));
            this.model_option = mappedModels;
            this.original_model_option = [...mappedModels];
          }
        });
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      this.year_option = [];
      for (let year = currentYear; year >= currentYear - 20; year--) {
        this.year_option.push(year.toString());
      }
    },
    search() {
      this.isSearching = true;

      // Check if we need to get zip codes from the selected states
      let zipCodes = [...this.selectedZipCodes]; // Create a copy of the array

      // If no zip codes and states are selected, use the states' zip codes
      if (zipCodes.length === 0 && this.selectedStates.length > 0) {
        zipCodes = this.selectedStates.map(state => this.stateZipMap[state] || '').filter(zip => zip !== '');
        console.log(`No zip codes provided, using ${zipCodes.join(', ')} from selected states`);
      }

      // Prepare search parameters
      const searchParams = {
        // For backward compatibility with the API
        make: this.selectedMakes && this.selectedMakes.length > 0 ?
          this.selectedMakes[0] : '',
        model: this.selectedModels && this.selectedModels.length > 0 ?
          this.selectedModels[0] : '',
        zip_code: zipCodes.length > 0 ? zipCodes[0] : '', // First zip code for backward compatibility

        // Include the full arrays for our URL and localStorage
        makes: this.selectedMakes,
        models: this.selectedModels,
        states: this.selectedStates,
        zip_codes: zipCodes,

        // Year range - include both specific fields and backward compatibility
        year: this.filter.year_min || '',
        year_min: this.filter.year_min || '',
        year_max: this.filter.year_max || '',

        // Price range
        price_min: this.filter.price_min || '',
        price_max: this.filter.price_max || '',

        // Odometer range
        odometer_min: this.filter.odometer_min || '',
        odometer_max: this.filter.odometer_max || '',

        // Location - use the determined radius
        radius: this.filter.radius ? parseInt(this.filter.radius) : 50,

        // Other parameters
        body_style: this.filter.bodyStyle || '',

        // Include required parameters for API
        credit_score: 641,
        bhph: 0,

        // Add timestamp for persistence tracking
        timestamp: new Date().getTime()
      };

      console.log("Search with parameters:", searchParams);

      // Save to localStorage for persistence
      localStorage.setItem('vehicle_filter', JSON.stringify(searchParams));

      // Emit search event with parameters
      this.$emit('search', searchParams);

      // Close dialog after search is initiated
      setTimeout(() => {
        this.isSearching = false;
        this.dialog = false;
      }, 1000);
    }
  }
};
</script>

<style scoped>
.filter-btn {
  text-transform: none;
  font-weight: bold;
}

.close-btn {
  border: 1px solid #e0e0e0;
  transition: all 0.3s;
}

.close-btn:hover {
  background-color: #f5f5f5;
}

.states-list,
.makes-list,
.models-list {
  scrollbar-width: thin;
}

.states-list::-webkit-scrollbar,
.makes-list::-webkit-scrollbar,
.models-list::-webkit-scrollbar {
  width: 8px;
}

.states-list::-webkit-scrollbar-track,
.makes-list::-webkit-scrollbar-track,
.models-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.states-list::-webkit-scrollbar-thumb,
.makes-list::-webkit-scrollbar-thumb,
.models-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.states-list::-webkit-scrollbar-thumb:hover,
.makes-list::-webkit-scrollbar-thumb:hover,
.models-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.state-item {
  border-bottom: 1px solid #f0f0f0;
}

.state-item:last-child {
  border-bottom: none;
}

.state-checkbox >>> .v-input--selection-controls__input {
  margin-right: 4px;
}

.state-count {
  font-size: 12px;
  font-weight: 500;
}

.floating-close-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.floating-close-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
</style>
